import { Component, signal } from '@angular/core';
import { ReportingSectionReport, ReportingSectionReportLesson, TakeStatus } from '@mira-avant/mtlibs';
import { NavigationService } from '../../../../../services/navigation.service';
import { SectionService } from '../../../../../services/section.service';
import { AngularModule } from '../../../../../modules/angular.module';
import { ZorroModule } from '../../../../../modules/zorro.module';
import { DisplayNamePipe } from '../../../../../pipes/display-name.pipe';
import { JourneyReports } from '../../../../../services/journey-reports';

@Component({
	selector: 'app-journey-section-report',
	standalone: true,
	imports: [AngularModule, ZorroModule, DisplayNamePipe],
	templateUrl: './journey-section-report.html',
	styleUrl: './journey-section-report.scss',
})
export class JourneySectionReport {
	report = signal<ReportingSectionReport | undefined>(undefined);
	selectedLesson = signal<ReportingSectionReportLesson | undefined>(undefined);
	selectedLessonIndex = signal(1);
	readonly TakeStatus = TakeStatus;

	constructor(
		public nav: NavigationService,
		private journeyReportsService: JourneyReports,
		public sectionService: SectionService
	) {
		this.loadReport();
	}

	private async loadReport() {
		const matrixParams = await this.nav.matrixParams$.getValue();
		const sectionUuid: string = matrixParams['sectionUuid'];

		const startOfYear = new Date(new Date().getFullYear(), 0, 1);
		const now = new Date();

		const report = await this.journeyReportsService.getSectionReport$(sectionUuid, startOfYear, now);

		this.report.set(report);
		this.selectLesson(1);
	}

	range(n: number): number[] {
		return Array.from({ length: n }, (_, i) => i);
	}

	selectStudent(studentUuid: string): void {
		this.nav.navigateWithMatrix$(['/', 'my', 'reports'], { studentUuid });
	}

	selectLesson(number: number): void {
		const r = this.report();
		if (!r) return;

		this.selectedLesson.set(r.lessons[number - 1]);
		this.selectedLessonIndex.set(number);
	}
}
